module.exports = __webpack_public_path__ + "img/preview-1.d7357fd6.png";